import { render, staticRenderFns } from "./AppControls.vue?vue&type=template&id=5a504312&scoped=true&"
import script from "./AppControls.vue?vue&type=script&lang=js&"
export * from "./AppControls.vue?vue&type=script&lang=js&"
import style0 from "./AppControls.vue?vue&type=style&index=0&id=5a504312&scoped=true&lang=css&"
import style1 from "./AppControls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a504312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a504312')) {
      api.createRecord('5a504312', component.options)
    } else {
      api.reload('5a504312', component.options)
    }
    module.hot.accept("./AppControls.vue?vue&type=template&id=5a504312&scoped=true&", function () {
      api.rerender('5a504312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppControls.vue"
export default component.exports